import { useJwtUser as i } from "./useJwtUser.js";
import "react-oauth2-pkce";
import "./jwt-to-user.helper-2e5f8f3e.js";
import "jwt-decode";
function p(t) {
  const { children: e, roles: r } = t, { user: o } = i();
  return r !== void 0 && !(o != null && o.hasAnyOfTheseSsoRoles(...r)) ? null : e;
}
export {
  p as Private
};
